import { render } from "./TwoColumn.vue?vue&type=template&id=9dd19da2&scoped=true"
import script from "./TwoColumn.vue?vue&type=script&lang=js"
export * from "./TwoColumn.vue?vue&type=script&lang=js"

import "./TwoColumn.vue?vue&type=style&index=0&id=9dd19da2&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd19da2"]])

export default __exports__